import React, { Component } from 'react'
import styled from 'styled-components'

import LinkItem from './LinkItem'

interface Props {
  links: ILink[]
  linkClicked: (l: ILink, m?: boolean) => void
  openDeleteModal: (s: string) => void
  travelling: boolean | undefined
  toggleEditModal: (a: any, b: boolean) => void
}

interface ILink {
  url: string
  logo: string
  logo_hash: string
  image: string
  image_hash: string
  title: string
  description: string
  timestamp: number
}

export default class Links extends Component<Props> {
  scroller: any

  constructor(props: Props) {
    super(props)

    this.scroller = null
  }

  scrollToBottom() {
    this.scroller &&
      (this.scroller.scrollTo
        ? this.scroller.scrollTo(0, this.scroller.scrollHeight)
        : (this.scroller.scrollTop = this.scroller.scrollHeight))
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.links.length !== this.props.links.length) {
      this.scrollToBottom()
    }
  }

  componentDidMount() {
    this.scrollToBottom()
  }

  remove = (e: any, link: string) => {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    this.props.openDeleteModal(link);
  }

  edit = (e: any, item: any) => {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    this.props.toggleEditModal(item, true)
  }

  render() {
    const len = this.props.links.length
    const link_items = this.props.links.map((link, ii) => (
      <LinkItem
        nolazy={len - ii <= 3}
        key={link.timestamp}
        link={link}
        onClick={() => this.props.linkClicked(link)}
        onClickRaw={() => this.props.linkClicked(link, true)}
        onClickRemove={(e) => {this.remove(e, link.url)}}
        onClickEdit={(e) => {this.edit(e, link)}}
        travelling={this.props.travelling}
      />
    ))

    return (
      <LinksContainer {...{ ref: (r: any) => (this.scroller = r) } as any}>
        <div>
          {link_items}
        </div>
      </LinksContainer>
    )
  }
}

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: calc(100% - 80px);
  overflow-y: scroll;
  visibility: hidden;
  padding: 10px;
  margin-bottom: 30px;

  &:hover, & > div {
    visibility: visible;
  }
`
